<template>
  <v-container v-if="this.$store.getters.programsFetched">
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-title xs12 sm6>
            <div>
              <h1 class="block-header">Create Your Password</h1>
              <v-divider></v-divider>
              <p class="block-message"
                v-html="
                  $t('message.verifyAccount.welcomeMessage1', {
                    programName: this.$store.getters.getProgramDisplayName
                  })
                "
              ></p>

              <v-flex xs12 mt-2 v-if="this.$store.getters.hasEnrollmentKit">
                  <p class="block-message" v-html="$t('message.verifyAccount.welcomeMessage2')"></p>
                  <br>
                  <a :href="enrollmentKitPath()" download>Enrollment Kit</a>
              </v-flex>

              <v-flex xs12 mt-2 v-if="!this.$store.getters.isTDComplete">
                <p class="block-message" v-html="$t('message.verifyAccount.welcomeMessage3')"></p>
                <p v-html="$t('message.newAppInstructions')"></p>
              </v-flex>

            </div>
            <v-flex sm8 offset-sm2>
              <v-form v-model="valid" ref="form">
                <v-text-field
                  label="Password"
                  v-model="password1"
                  v-validate="password1Rules"
                  ref="password1"
                  name="password1"
                  :error-messages="errors.collect('password1')"
                  data-vv-as="Password"
                  type="password"
                ></v-text-field>

                <v-text-field
                  label="Confirm Password"
                  v-model="password2"
                  v-validate="password2Rules"
                  ref="password2"
                  name="password2"
                  :error-messages="errors.collect('password2')"
                  data-vv-as=" "
                  type="password"
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-card-title>
          <v-layout justify-center>
            <v-card-actions class="button-buffer">
              <v-btn
                block class="btn-primary ie-large-btn"
                @click="submit()"
                :disabled="!valid">create password</v-btn>
            </v-card-actions>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axiosMixin from '@/mixins/axiosMethods'

export default {
  data() {
    return {
      token: this.$route.params.token,
      ownerAction: this.$route.query.ownerAction,
      pwReset: this.$route.query.pwReset,
      password1: '',
      password2: '',
      valid: false
    }
  },
  computed: {
    password1Rules() {
      return {
            required: true,
            regex: /(?=^.{8,}$)(?=.*\d)(?![.\n])(?=.*[A-Za-z]).*$/
          }
    },
    password2Rules() {
      return {
            required: true,
            confirmed: 'password1'
          }
    }
  },
  mixins: [axiosMixin],
  methods: {
    enrollmentKitPath() {
      return (
        this.$store.getters.getEnrollmentKitPath
      )
    },
    submit() {
      if (this.password1.length == 0) {
        //not sure why the form is valid when the page first loads
        this.notifyWarn("Please enter password")
        return;
      }
      var url = 'api/v1/pub/participant'
      if (this.pwReset) {
        url += '/password/recover/set'
      } else {
        url += '/verifyAccount'
      }

      axios
        .post(url, {
          domain: this.$store.getters.getProgram.domain,
          password1: this.password1,
          password2: this.password2,
          code: this.token
        })
        .then(response => {
          var authenticatedUser = response.data
          this.$store.commit('setAuthenticatedUser', authenticatedUser)
          if (this.$store.getters.getProgram.domain === 'tdcomplete' && !this.pwReset) {
            this.$router.push('/lender-use-of-terms')
          } else {
            this.$router.push('/applicationList')
          }

        })
        .catch(error => {
            if (error.response && error.response.status == '417' && error.response.data.fieldErrors.length) {
                this.notifyWarn(error.response.data.fieldErrors[0].errorMessage)
            } else {
                this.notifyWarn('Error verifying account')
            }
        })
    },
    loadValidationMsgs() {
      const dict = {
        custom: {
          password1: {
            regex:
              'Password must contain at least 8 characters with upper/lower letters and numbers.',
            confirmed: 'Password does not match',
            required: 'Password does not match'
          }
        }
      }

      this.$validator.localize('en', dict)
    }
  },
  mounted() {
    this.loadValidationMsgs()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VerifyAccount.vue